import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalTrigger from '../common/ModalTrigger';
import { putRequest } from '../../requestUtils';
import './ProjectInvitationDecline.scss';
var ProjectInvitationDecline = /*#__PURE__*/function (_Component) {
  function ProjectInvitationDecline(props) {
    var _this;
    _classCallCheck(this, ProjectInvitationDecline);
    _this = _callSuper(this, ProjectInvitationDecline, [props]);
    _this.state = {
      message: ''
    };
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }
  _inherits(ProjectInvitationDecline, _Component);
  return _createClass(ProjectInvitationDecline, [{
    key: "handleInputChange",
    value: function handleInputChange(event) {
      var target = event.target;
      this.setState({
        message: target.value
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this$props = this.props,
        formUrl = _this$props.formUrl,
        csrfToken = _this$props.csrfToken;
      var message = this.state.message;
      return putRequest(formUrl, {
        status: 'rejected',
        message: message
      }, csrfToken).then(function () {
        window.location.reload();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var message = this.state.message;
      return /*#__PURE__*/React.createElement(ModalTrigger, {
        triggerText: "Decline Opportunity",
        buttonStyles: "secondary full-width",
        submitButtonText: "Decline",
        handleSubmit: this.handleSubmit,
        submitDisabled: !message,
        triggerType: "link",
        cancelButton: false,
        idKey: "decline-project-invitation-modal"
      }, /*#__PURE__*/React.createElement("div", {
        className: "style-guide"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "mb-8"
      }, "Decline project"), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 mb-3 "
      }, "Share with Clora the reasons why you are not interested in this opportunity to help us improve your marketplace experience."), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 medium-weight mb-8"
      }, "Why you are not interested in this opportunity?", /*#__PURE__*/React.createElement("span", {
        className: "required"
      })), /*#__PURE__*/React.createElement("textarea", {
        value: message,
        className: "form-control",
        placeholder: "Type here...",
        name: "message",
        id: "message",
        rows: "4",
        onChange: this.handleInputChange
      })));
    }
  }]);
}(Component);
ProjectInvitationDecline.propTypes = {
  formUrl: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired
};
export default ProjectInvitationDecline;